import { render, staticRenderFns } from "./SubEmpresaCardBuscaTerritoriosPY.vue?vue&type=template&id=197380e8&scoped=true&lang=pug"
import script from "./SubEmpresaCardBuscaTerritoriosPY.vue?vue&type=script&lang=js"
export * from "./SubEmpresaCardBuscaTerritoriosPY.vue?vue&type=script&lang=js"
import style0 from "./SubEmpresaCardBuscaTerritoriosPY.vue?vue&type=style&index=0&id=197380e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197380e8",
  null
  
)

export default component.exports